/** @jsxImportSource @emotion/react */
import React, { useCallback, useState } from 'react';
import { jsx, css } from '@emotion/react';
import { FormattedMessage } from 'components/i18n';
import {ModalBody, ModalHeader, ModalTitle, ModalFooter} from '@atlaskit/modal-dialog';
import Button, { LoadingButton } from '@atlaskit/button';
import Modal from './Modal';
import { ModalProps, FormModalOptions } from './types';

type Props<T extends {} = any> = FormModalOptions<T> & ModalProps  & {
};

const FormModal = <T extends {} = any,>({id, onClose, title, content, onSubmit, form: Form, initialValues, submitText, width}: Props<T>) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = useCallback(async (values: any)=> {
    if (onSubmit) {
      setIsSubmitting(true);
      try {
        await onSubmit(values);
        onClose();
      } finally {
        setIsSubmitting(false);
      }
    } else {
      onClose();
    }
  }, [onClose, onSubmit]);

  const handleSubmitClick = useCallback(() => {
    // document.getElementById(id)?.dispatchEvent(new Event('submit', { cancelable: true }));
    document.getElementById(id)?.click();
  }, []);

  return (
    <Modal
      onClose={onClose}
      autoFocus
      shouldScrollInViewport={false}
      width={width || 'medium'}
    >
      <ModalHeader>
        <ModalTitle>
          {title || (
            <FormattedMessage
              id='components.modals.delete.defaultTitle'
              defaultMessage='Delete this?'
            />
          )}
        </ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit} initialValues={initialValues} id={id} />
      </ModalBody>
      <ModalFooter>
        <Button appearance="subtle" onClick={onClose}>
          <FormattedMessage id='components.modals.form.cancel' defaultMessage='Cancel' />
        </Button>
        <LoadingButton appearance="primary" type="submit" onClick={handleSubmitClick} isLoading={isSubmitting}>
          {submitText || <FormattedMessage id='components.modals.form.save' defaultMessage='Save' />}
        </LoadingButton>
      </ModalFooter>
    </Modal>
  );
};
export default FormModal;
